import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_PRODUCTIVIDAD_VOLCADORAS } from '../../../../config/forms'
import CamposDemoraEnVolcadora from './CamposDemoraEnVolcadora.jsx'

function EdicionDemora (props) {
  const { data, change: formChange, motivosDemora, volcadoras } = props
  const [fechaDesde, setFechaDesde] = useState(moment(new Date(data.inicioDeDemora)).format('DD/MM/YYYY'))
  const [fechaHasta, setFechaHasta] = useState(moment(new Date(data.finDeDemora)).format('DD/MM/YYYY'))
  const [hInicio, setHInicio] = useState(moment(data.inicioDeDemora).format('HH:mm:ss'))
  const [hFin, setHFin] = useState(moment(data.finDeDemora).format('HH:mm:ss'))
  const [observaciones, setObservaciones] = useState(data.observacionesSupervisor)
  const [dataInicial, setDataInicial] = useState(false)

  const rol = props.roles.filter(roles => roles === 'SUPERVISOR' || roles === 'SUPMANTENIMIENTO' || roles === 'DESARROLLADOR')
  const rolAutorizado = (rol[0] === 'SUPERVISOR' || rol[0] === 'SUPMANTENIMIENTO' || rol[0] === 'DESARROLLADOR')

  useEffect(() => {
    function getData () {
      formChange('fechaInicioDemora', moment(new Date(data.inicioDeDemora)).format('DD/MM/YYYY'))
      formChange('fechaFinDemora', moment(new Date(data.finDeDemora)).format('DD/MM/YYYY'))
      formChange('horaInicio', moment(data.inicioDeDemora).format('HH:mm:ss'))
      formChange('horaFin', moment(data.finDeDemora).format('HH:mm:ss'))
      formChange('motivoDemora', data.claveMotivoDeDemora.trim())
      formChange('volcadoraCamiones', data.volcadoraCamiones.trim())
      formChange('supervisor', data.usuarioSupervisor)
      formChange('observacionesDemora', data.observacionesSupervisor)

      setFechaDesde(moment(new Date(data.inicioDeDemora)).format('DD/MM/YYYY'))
      setFechaHasta(moment(new Date(data.finDeDemora)).format('DD/MM/YYYY'))
      setHInicio(moment(data.inicioDeDemora).format('HH:mm:ss'))
      setHFin(moment(data.finDeDemora).format('HH:mm:ss'))
      setObservaciones(data.observacionesSupervisor)
    }

    if (!dataInicial) {
      getData()
      setDataInicial(true)
    }
  }, [formChange, data, setDataInicial, dataInicial])

  return (
    <>
      <div style={{ padding: '2%' }}>
        <CamposDemoraEnVolcadora
          data={data}
          motivosDemora={motivosDemora}
          volcadoras={volcadoras}
          fechaDesde={fechaDesde}
          fechaHasta={fechaHasta}
          hInicio={hInicio}
          hFin={hFin}
          rolAutorizado={rolAutorizado}
          observaciones={observaciones}
        />
      </div>
    </>
  )
}

const selector = formValueSelector(FORM_PRODUCTIVIDAD_VOLCADORAS)

const mapStateToProps = (state) => ({
  fechaInicioDemora: selector(state, 'fechaInicioDemora'),
  fechaFinDemora: selector(state, 'fechaFinDemora'),
  horaInicio: selector(state, 'horaInicio'),
  horaFin: selector(state, 'horaFin'),
  motivosDemora: state.volcadora.motivosDemoraVolcadora,
  volcadoras: state.volcadora.volcadorasCamiones,
  roles: state.auth.roles
})

const withRedux = connect(mapStateToProps, null)

const withReduxForm = reduxForm({
  form: FORM_PRODUCTIVIDAD_VOLCADORAS
})

export default withRedux(withReduxForm(EdicionDemora))
